import { render, staticRenderFns } from "./domainListModal.vue?vue&type=template&id=8f5647c4&scoped=true&"
import script from "./domainListModal.vue?vue&type=script&lang=js&"
export * from "./domainListModal.vue?vue&type=script&lang=js&"
import style0 from "./domainListModal.vue?vue&type=style&index=0&id=8f5647c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5647c4",
  null
  
)

export default component.exports